<template>
  <div :class="['sidebar', { 'sidebar-active': isOpen }]">
    <div class="sidebar-header">
    </div>

    <!-- Contenu du menu principal -->
    <div class="sidebar-content">
      <ul>
        <!-- Liens du menu de la navbar -->
        <li>
          <DropdownComponent @navigateToProducts="navigateToProducts" @click="closeSidebar" />
        </li>
        <li @click="closeNav">
          <a href="http://supracare.ma" target="_blank" >Présentation</a>
        </li>
        <li @click="closeNav">
          <a href="http://supracare.ma/services" target="_blank">Grantie</a>
        </li>
        <li @click="closeSidebar">
          <router-link to="/marques">Marques</router-link>
        </li>
        <li @click="closeNav">
          <a href="http://supracare.ma/contact" target="_blank">Contact</a>
        </li>
      </ul>

      <!-- Section Compte -->
      <!-- Section Compte -->
<hr />

<!-- Si un utilisateur est connecté -->
<div v-if="isLoggedIn">
  <!-- Si c’est un client -->
  <div v-if="userRole === 'account'" class="user-dropdown">
    <button class="option-item" @click="toggleDropdown">
      <router-link to="/account" class="link-content" @click="closeSidebar">
        <i class="fas fa-user cart-icon"></i>
        <span class="option-item1">{{ userName }}</span>
      </router-link>
    </button>
    <ul class="dropdown-menu">
      <li><router-link to="/account" @click="closeSidebar">Mon compte</router-link></li>
      <li><router-link to="/wishlist" @click="closeSidebar">Mes listes de souhaits</router-link></li>
      <li><a href="#" @click.prevent="logout">Se déconnecter</a></li>
    </ul>
  </div>

  <!-- Si c’est un admin -->
  <div v-else-if="userRole === 'admin'" class="user-dropdown">
    <button class="option-item" @click="toggleDropdown">
      <router-link to="/admin/dashboard" class="link-content" @click="closeSidebar">
        <i class="fas fa-user-shield cart-icon"></i>
        <span class="option-item1">Admin</span>
      </router-link>
    </button>
    <ul class="dropdown-menu">
      <li><router-link to="/dashboardAdmin" @click="closeSidebar">Tableau de bord</router-link></li>
      <li><a href="#" @click.prevent="logout">Se déconnecter</a></li>
    </ul>
  </div>
</div>

<!-- Si aucun utilisateur n’est connecté -->
<router-link v-else to="/connexion" class="option-item1" @click="closeSidebar">
  Connexion
</router-link>

    
    </div>
  </div>
</template>

<script>
import DropdownComponent from "@/components/DropdownComponent.vue";

export default {
  name: "SidebarI",
  components: {
    DropdownComponent,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
    data() {
    return {
      isLoggedIn: false,
      userName: "",
      dropdownOpen: false,
      userRole: "",
      showDropdown: false,
    };
  },
  mounted() {
    this.checkUserStatus();

    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      this.isLoggedIn = true;
      this.userName = `${user.prenom} ${user.nom}`;
      this.userRole = user.role; // Récupère bien le rôle : "admin" ou "account"
    }
  },
  methods: {

       toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    closeSidebar() {
      // Émettre un événement pour fermer le sidebar
      this.$emit("closeSidebar");
      },
     navigateToProducts() {
      // Naviguer vers la page des produits et fermer le sidebar
      this.$router.push("/DropdownComponent");
      this.closeSidebar(); 
    },
    closeNav() {
     
      this.closeSidebar();
    },
    goToLogin() {
  
      this.$router.push("/connexion");
      this.closeSidebar();  
    },
     logout() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('redirectAfterLogin');
      this.isLoggedIn = false;
      this.userName = "";
      this.userRole = "";
      this.$router.push('/connexion');
      this.closeSidebar();
    },
    checkUserStatus() {
      const user = sessionStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        this.userName = `${parsedUser.prenom} ${parsedUser.nom}`;
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
        this.userName = "";
      }
    }
  },
  watch: {
    '$route'() {
      this.checkUserStatus();
    }
  }
};
</script>

<style scoped>

/* Espacement entre l'icône et le nom de l'utilisateur */
.user-dropdown .link-content {
  display: flex;
  align-items: center;
  gap: 8px; /* espace horizontal entre icône et texte */
}

/* Optionnel : meilleure lisibilité du nom */
.user-dropdown .option-item1 {
  font-weight: 600;
  font-size: 15px;
}
:root{
  --brand:#00998B;
  --brand-dark:#05305b;
  --ink:#22313a;
}

/* ====== Sidebar ====== */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: rgba(255,255,255,0.96);
  color: var(--ink);
  border-right: 1px solid rgba(0,0,0,0.08);
  box-shadow: 0 0 0 rgba(0,0,0,0);
  backdrop-filter: blur(6px);
  transform: translateX(-100%);
  transition: transform 0.4s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.3s ease;
  z-index: 1000;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* ===== Animation quand la sidebar s’ouvre ===== */
.sidebar-active {
  transform: translateX(0);
  box-shadow: 0 0 40px rgba(0,0,0,0.3);
}

/* Animation légère des liens */
.sidebar-content a {
  display: block;
  color: var(--ink);
  text-decoration: none;
  padding: 12px;
  font-weight: 600;
  border-radius: 8px;
  transition: background 0.2s ease, transform 0.2s ease;
}
.sidebar-content a:hover {
  background: #eefbf9;
  transform: translateX(4px);
}

/* Effet fade-in du contenu */
.sidebar-content {
  animation: fadeIn 0.5s ease;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ====== Disparition automatique sur desktop ====== */
@media (min-width: 1040px) {
  .sidebar {
    display: none !important;
  }
}

/* ====== Mode sombre ====== */
@media (prefers-color-scheme: dark) {
  .sidebar {
    background: #0f1720;
    color: #e6edf1;
    border-right: 1px solid rgba(255,255,255,0.1);
  }
  .sidebar-content a {
    color: #e6edf1;
  }
  .sidebar-content a:hover {
    background: #142231;
    color: #73d8cf;
  }
}
@media (prefers-color-scheme: dark) {
  /* Corrige le fond clair du bouton utilisateur en mode sombre */
  .user-dropdown .option-item {
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  /* Texte du nom visible en blanc */
  .user-dropdown .option-item1 {
    color: #ffffff !important;
  }

  /* Icône utilisateur turquoise clair */
  .user-dropdown .fa-user {
    color: #73d8cf !important;
  }

  /* Survol agréable */
  .user-dropdown .option-item:hover {
    background-color: rgba(255, 255, 255, 0.05) !important;
  }
}


</style>
